import React from "react";

const HorizontalLine = () => {
  return (
    <hr
      className="my-4"
      style={{
        background:
          "linear-gradient(90deg, rgba(243, 233, 225, 0.2) 0%, #000 48.44%, rgba(243, 233, 225, 0.2) 100%)",
        border: "2px #000",
        height: "1px",
      }}
    />
  );
};

export default HorizontalLine;
